export const isValidIndex = (i: number) => i >= 0;
